import { useMutation } from "react-query";
import * as Redux from "react-redux";

import { FormService } from "client/services";
import {
  errorActions,
  FormCompletion,
  formCompletionActions,
  RootState,
} from "client/store";

export function useSaveFormState(): {
  saveFormState: (formCompletionData: Partial<FormCompletion>) => void;
} {
  const formCompletionState = Redux.useSelector(
    ({ formCompletion }: RootState) => formCompletion
  );

  const dispatch = Redux.useDispatch();
  const { mutate } = useMutation(
    (args: Partial<FormCompletion>) =>
      FormService.saveFormState({
        ...formCompletionState,
        ...args,
      }),
    {
      onSuccess: ({ formCompletedState }) => {
        if (formCompletedState) {
          dispatch(formCompletionActions.setFormCompletion(formCompletedState));
        }
      },
      onError: (err: Error) => {
        dispatch(errorActions.setError(err.message));
      },
    }
  );

  return { saveFormState: mutate };
}
